module.exports = __webpack_public_path__ + "img/d3.31beb1c5.jpg";